import { Component } from 'react';
import PropTypes from 'prop-types';

class DelayWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isWaiting: true,
    };
  }

  componentDidMount() {
    const { duration } = this.props;
    this.delay = setTimeout(() => {
      this.setState({
        isWaiting: false,
      });
    }, duration);
  }

  componentWillUnmount() {
    clearTimeout(this.delay);
  }

  render() {
    const { isWaiting } = this.state;
    const { children } = this.props;
    return isWaiting ? null : children;
  }
}

DelayWrapper.propTypes = {
  children: PropTypes.any,
  duration: PropTypes.number,
};

DelayWrapper.defaultProps = {
  duration: 500,
};

export default DelayWrapper;
